import type ModuleButtonsType from '../components/ModuleButtonsType';
import { showDeleteDialog, showDetailsReportingDialog, Utils } from 'app/main/components';
import { showAddNotesDialog } from 'app/main/submodules/notes/NotesAddDialog';
import { shareDetailsPage } from 'app/main/components/dialogs/ShareDialog';
import { showFastAddDialog } from '../components/FastAddDialog';

import { showCoursesAttendersAddDialog } from './courses-attenders/CoursesAttendersAddDialog';

export default {
	view: {
		itemButtons: [
			{
				name: 'VIEW_ITEM_BUTTON_EDIT',
				icon: 'edit',
				hidden: ({ authorizer }) => authorizer.cannot('update', 'courses'),
				action: ({ dispatch, updateRefresh, model }) =>
					dispatch(showFastAddDialog({ module: 'courses', updateRefresh, isUpdate: true, model }))
			},
			{
				name: 'VIEW_ITEM_BUTTON_ADD_COPY',
				icon: 'content-copy',
				iconAdd: true,
				hidden: ({ authorizer }) => authorizer.cannot('create', 'courses'),
				action: ({ model, t }) => {
					const { crss_title } = model;
					Utils.openLink({
						pathname: '/courses/add',
						state: {
							model: { ...model, crss_title: crss_title + t('COPY') }
						}
					});
				}
			},
			{
				name: 'VIEW_ITEM_BUTTON_NEW_NOTE',
				icon: 'comment-text-multiple-outline',
				iconAdd: true,
				action: ({ model, dispatch }) =>
					dispatch(showAddNotesDialog({ model: { note_table: 'courses', note_table_uid: model.crss_uid } }))
			},
			{
				name: 'VIEW_ITEM_BUTTON_DELETE',
				icon: 'delete',
				color: 'red',
				hidden: ({ authorizer }) => authorizer.cannot('delete', 'courses'),
				action: ({ model, dispatch, updateRefresh }) =>
					dispatch(
						showDeleteDialog({
							module: 'courses',
							id: model.crss_uid,
							title: model.crss_title,
							updateRefresh
						})
					)
			}
		],
		headerButtons: [
			{
				name: 'VIEW_HEADER_BUTTON_NEW',
				icon: 'plus-circle',
				hidden: ({ authorizer }) => authorizer.cannot('create', 'courses'),
				action: () => Utils.openLink({ pathname: '/courses/add' })
			}
		]
	},
	details: {
		headerButtons: [
			// {
			// 	name: 'DETAILS_HEADER_BUTTON_FAVOURITE',
			// 	icon: 'star-outline',
			// 	disabled: () => true,
			// 	action: () => {}
			// },
			{
				name: 'VIEW_HEADER_BUTTON_EXPORT',
				icon: 'file-export',
				hidden: ({ authorizer }) => authorizer.cannot('export', 'dems'),
				action: ({ model, dispatch, settings, sysSettings }) =>
					showDetailsReportingDialog({ model, dispatch, settings, sysSettings })
			},
			{
				name: 'DETAILS_HEADER_BUTTON_SHARE',
				icon: 'share-variant',
				action: ({ model, dispatch, settings, t }) => shareDetailsPage({ model, dispatch, settings, t })
			},
			{
				name: 'DETAILS_HEADER_BUTTON_SHOW_LOG',
				icon: 'timeline-clock-outline',
				hidden: ({ authorizer }) => authorizer.cannot('view', 'logs'),
				disabled: ({ isEdit }) => isEdit,
				action: ({ switchShowLogs }) => switchShowLogs()
			},
			{
				name: 'DETAILS_HEADER_BUTTON_DELETE',
				icon: 'delete',
				color: 'red',
				hidden: ({ authorizer }) => authorizer.cannot('delete', 'courses'),
				action: ({ model, dispatch }) =>
					dispatch(
						showDeleteDialog({
							module: 'courses',
							id: model.crss_uid,
							title: model.crss_title
						})
					)
			}
		],
		fabs: [
			{
				id: 'summary',
				name: 'ACTION_EDIT',
				icon: 'edit',
				hidden: ({ authorizer }) => authorizer.cannot('update', 'courses'),
				action: ({ switchEdit }) => switchEdit()
			},
			{
				id: 'courses_attenders',
				name: 'DETAILS_HEADER_BUTTON_NEW_USER',
				icon: 'account-circle',
				iconAdd: true,
				hidden: ({ authorizer }) => authorizer.cannot('update', 'courses'),
				action: ({ model, dispatch, updateRefresh }) =>
					dispatch(
						showCoursesAttendersAddDialog({
							model,
							updateRefresh
						})
					)
			}
		]
	}
} as ModuleButtonsType;
